module.exports = __webpack_public_path__ + "static/img/menu.91080c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.png
// module id = 01ru
// module chunks = 1